import { Flex, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text } from "@chakra-ui/react";
import { RootState, useAppSelector } from "../../../store";

interface InfoStatusModalProps {
    isOpen: boolean;
    onClose: () => void;
    currentStatus: string | null;
}

export const InfoStatusModal = ({ isOpen, onClose, currentStatus }: InfoStatusModalProps) => {
    const { candidatesModalInfo, currentVacancyName } = useAppSelector(
        (state: RootState) => state.analytics
    );
    return (
        <Modal isCentered isOpen={isOpen} onClose={onClose}>
            <ModalOverlay backdropFilter="blur(3px)" />
            <ModalContent maxW="50vw" gap="24px" px="24px" paddingTop="32px" paddingBottom="24px">
                <ModalHeader p={0}>
                    <Text color="#3b515e" fontWeight={700} fontSize={32}>{`Список кандидатов: ${currentVacancyName ? currentVacancyName : currentStatus}`}</Text>
                </ModalHeader>
                <ModalBody p={0}>
                    <Flex flexDirection="column">
                        <Flex bgColor="#f3f4f680" padding="12px" borderRadius="6px" justifyContent="space-between">
                            <Flex gap="6px" flexDirection="column" flexGrow={1}>
                                <Text fontWeight={500} color="#65758b">
                                    Этап:
                                </Text>
                                <Text color="#3b515e" fontWeight={700} fontSize={16}>
                                    {currentStatus}
                                </Text>
                            </Flex>
                            <Flex gap="6px" flexDirection="column" flexGrow={1}>
                                <Text fontWeight={500} color="#65758b">
                                    Кандидатов:
                                </Text>
                                <Text color="#3b515e" fontWeight={700} fontSize={16}>
                                    {candidatesModalInfo?.total}
                                </Text>
                            </Flex>
                        </Flex>
                    </Flex>
                    <Flex fontWeight={500} flexDirection="column" marginTop="32px" maxH="500px" overflowY="auto" gap="6px">
                        {candidatesModalInfo?.candidates.map((el) => {
                            return (
                                <Flex                             
                                border="1px solid #e1e7ef" 
                                padding="12px" 
                                borderRadius="6px"
                                justifyContent="space-between"
                                _hover={{
                                    backgroundColor: "#f3f4f680",
                                    cursor: "pointer",
                                }}>
                                    <Flex flexDirection="column" gap="6px">
                                        <Text color="#3b515e" fontWeight={600}>{el.name}</Text>
                                        <Text color="#65758b" fontWeight={600}>{el.vacancy_name}</Text>
                                    </Flex>
                                    <Text alignSelf="center" height="max-content" padding="2px 8px" borderRadius="9999px" border="1px solid #e1e7ef" color="#65758b" fontWeight={600}>{`Дней в статусе: ${el.days_in_status}`}</Text>
                                </Flex>

                            )
                        })}
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}